module.exports = __webpack_public_path__ + "media/andenes/dimensions-3abd897d.webp";